import { Injectable } from '@angular/core';
import { EMPTY, filter, Subject, switchMap } from 'rxjs';
import { PaymentsService } from './payments.service';
import { LoggingService } from '@boma/supplier-portal/shared/services';
import { catchError, tap } from 'rxjs/operators';
import { ProfileService } from '@boma/website/shared';

@Injectable({ providedIn: 'root' })
export class PaymentsFacade {
  private readonly savingTransactionSubject = new Subject<boolean>();
  readonly savingTransaction$ = this.savingTransactionSubject.asObservable();

  constructor(
    private paymentsService: PaymentsService,
    private profileService: ProfileService,
    private loggingService: LoggingService
  ) {}

  createTransactionForBatch(batchId: string) {
    this.savingTransactionSubject.next(true);
    return this.profileService.data$.pipe(
      tap((profile) => {
        this.loggingService.logDebug(
          'PROFILE ENTITY FOUND',
          profile,
          'STARTING PAYMENT'
        );
      }),
      filter((data) => !!data.selectedEntity),
      switchMap((data) =>
        this.paymentsService.createOrderBatchTransaction(
          data.selectedEntity.id,
          batchId
        )
      ),
      tap((transaction) => {
        this.loggingService.logDebug('Transaction created!', transaction);
        this.savingTransactionSubject.next(false);
      }),
      catchError((err) => {
        this.savingTransactionSubject.next(false);
        return EMPTY;
      })
    );
  }
}
